/*eslint-disable*/
const Keycloak = require("keycloak-js").default;

const {
  REACT_APP_KEYCLOAK_URL: KEYCLOAK_URL,
  REACT_APP_KEYCLOAK_REALM: KEYCLOAK_REALM,
  REACT_APP_KEYCLOAK_CLIENT_ID: KEYCLOAK_CLIENT_ID,
} = process.env;

const keycloak = new Keycloak({
  url: KEYCLOAK_URL,
  realm: KEYCLOAK_REALM,
  clientId: KEYCLOAK_CLIENT_ID,
});

export const keycloakInitOptions = {
  onLoad: "check-sso",
  silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
  pkceMethod: "S256",
  checkLoginIframe: false,
};

export default keycloak;
